'use client';

import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import classNames from 'classnames';
import { ChevronDown } from 'components/gruenland/icons/ChevronDown';

type Props = {
  itemsClassName?: string;
  children?: React.ReactNode;
  label?: React.ReactNode;
};

const Picker: React.FC<Props> = ({ children, itemsClassName, label }) => {
  return (
    <Menu as="div" className="group relative rounded-lg border border-neutrals-black-20 lg:data-[open]:rounded-b-none">
      <>
        <MenuButton className="relative z-20 flex min-h-[64px] w-full items-center gap-[30px] p-3">
          {label}
          <ChevronDown className="transition-transform group-data-[open]:rotate-180" />
        </MenuButton>

        <MenuItems
          transition
          modal={false}
          className={classNames(
            'z-20 origin-top transition ease-out data-[closed]:scale-95 data-[closed]:opacity-0 lg:absolute lg:-inset-x-px lg:rounded-b-lg lg:border lg:border-neutrals-black-20 lg:bg-white lg:shadow-lg',
            itemsClassName,
          )}
        >
          {children}
        </MenuItems>
      </>
    </Menu>
  );
};

export default Picker;
